module.exports = __webpack_public_path__ + "static/media/close.0842eff2.svg";